import { STEP_KEYS, type StepDataState, type StepKey } from "@/types/Form";

export const initialStepDataState = STEP_KEYS.reduce<Record<StepKey, StepDataState>>(
  (acc, key) => {
    acc[key] = "unknown";
    return acc;
  },
  {} as Record<StepKey, StepDataState>,
);
